import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFundsData } from '../redux/pages/actions';
import { overviewFundsSelector } from '../redux/pages/selectors';
import { raptorPlatformIdSelector } from '../redux/raptorPlatform/selectors';
import { getFundsRoute } from '../routes/endpoints/general.routes';
import axios from 'axios';

export const useAppendOverviewFunds = (
  fundType?: string,
  rsResource?: string[],
) => {
  const overviewFunds = useSelector(overviewFundsSelector);
  const selectedRaptorPlatformId = useSelector(raptorPlatformIdSelector);

  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();

  const cacheKey = `${fundType}_${rsResource}_${selectedRaptorPlatformId || 'default'}`;

  const dispatch = useDispatch();
  useEffect(() => {
    if (fundType && rsResource) {
      const fundData = overviewFunds?.[cacheKey];
      // Refetch when missing, or when cached rows predate isDemoFund mapping.
      const needsRefresh =
        !fundData ||
        fundData.fundData.some((fund) => !('isDemoFund' in fund));

      if (needsRefresh) {
        const route = getFundsRoute(
          fundType,
          rsResource,
          selectedRaptorPlatformId,
        );
        dispatch(
          fetchFundsData(
            fundType,
            rsResource,
            route,
            source,
            selectedRaptorPlatformId,
          ),
        );
      }
    }
  }, [cacheKey]);

  return overviewFunds && fundType
    ? overviewFunds[
      `${fundType}_${rsResource}_${selectedRaptorPlatformId || 'default'}`
    ]?.requestedData
    : null;
};
